import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { BACKEND_APIS } from "@constants"
import { autoEuropePricingIdListData, autoEuropePricingIdIsLoading } from "Pages/AutoEuropeTool/PricingId/@signals"

const PRICING_ID_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/pricing-id`

export default function useAutoEuropePricingIdTable() {
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		batch(() => {
			autoEuropePricingIdIsLoading.value = true
			autoEuropePricingIdListData.value = []
		})
		getSubmit(`${PRICING_ID_API}/list`)
			.then(data => {
				batch(() => {
					autoEuropePricingIdListData.value = data
					autoEuropePricingIdIsLoading.value = false
				})
			})
			.catch(() => {
				autoEuropePricingIdIsLoading.value = false
				showToast.error("Error loading Pricing ID records")
			})
	}, [])

	return { getTableData }
}